module.exports = __webpack_public_path__ + "img/logo-chevy.eac87dcb.png";